/**
 * Created by PanJiaChen on 16/11/18.
 */
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return ''
  } else if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      // return ['日', '一', '二', '三', '四', '五', '六'][value ]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}
export function pickChange (val) {
  // console.log('val', val[1])
  // console.log('val', val[1].substring(0, 11) + '23:59:59')
  if (val === null) {
    this.query.startDate = ''
    this.query.endDate = ''
  } else {
    this.query.startDate = val[0]
    // if (val[1].substring(11, 19) === '00:00:00') {
    //   this.query.endDate = val[1].substring(0, 11) + '23:59:59'
    // } else {
    this.query.endDate = val[1]
    // }
    // let beginDate = [val[0], this.query.endDate]
    // this.$set(this, 'beginDate', beginDate)
    // console.log('this', this)
  }
}

/**
 * 阿拉伯数字转中文数字,
 * 如果传入数字时则最多处理到21位，超过21位js会自动将数字表示成科学计数法，导致精度丢失和处理出错
 * 传入数字字符串则没有限制
 * @param {number|string} digit
 */
export function transToChinese (money) {
  if (money) {
    money = money.toString() || ''
    // 汉字的数字
    var cnNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    // 基本单位
    var cnIntRadice = ['', '十', '百', '千']
    // 对应整数部分扩展单位
    var cnIntUnits = ['', '万', '亿', '兆']
    // 对应小数部分单位
    var cnDecUnits = ['角', '分', '毫', '厘']
    // 整数金额时后面跟的字符
    var cnInteger = '整'
    // 整型完以后的单位
    var cnIntLast = '元'
    // 如果为负数
    // var cnIntMinus = '负'
    // 负号处理后的数字
    var cash
    // 分离金额后用的数组，预定义
    var parts
    // 金额整数部分
    var integerNum
    // 金额小数部分
    var decimalNum
    // 输出的中文金额字符串
    var chineseStr = ''

    // 判断空
    if (money === '') {
      return ''
    }
    // 判断正负
    if (money.charAt(0) === '-') {
      // chineseStr += cnIntMinus;
      cash = money.slice(1)
    } else {
      cash = money
    }
    // 转换为浮点数类型,会自动去掉首尾的0
    cash = parseFloat(cash)
    // console.log('cash', cash)
    if (cash === 0) {
      chineseStr = cnNums[0] + cnIntLast + cnInteger
      return chineseStr
    }

    // 转换为字符串
    cash = cash.toString()
    if (cash.indexOf('.') === -1) {
      integerNum = cash // 金额整数部分
      decimalNum = '' // 金额小数部分
    } else {
      parts = cash.split('.')
      integerNum = parts[0] // 金额整数部分
      decimalNum = parts[1].substr(0, 4) // 金额小数部分
    }
    // console.log('integerNum', integerNum)
    // console.log('decimalNum', decimalNum)
    // 转换整数部分
    if (integerNum !== '-' && parseInt(integerNum, 10) > 0) {
      var intLen = integerNum.length
      var zero = 0 // 标记零出现次数
      for (let i = 0; i < intLen; i++) {
        var intChar = integerNum.substr(i, 1)
        var intSlen = intLen - i - 1
        var divided = intSlen / 4
        var remain = intSlen % 4

        if (intChar === '0') {
          zero++
        } else {
          if (zero > 0) {
            chineseStr += cnNums[0]
          }
          zero = 0
          chineseStr += cnNums[parseInt(intChar)] + cnIntRadice[remain]
        }
        if (remain === 0 && divided > 0) {
          chineseStr += cnIntUnits[divided]
        }
      }
      chineseStr += cnIntLast // 加上'元'字
    }

    if (decimalNum !== '') { // 小数部分存在时
      var decLen = decimalNum.length
      for (let i = 0; i < decLen; i++) {
        var decChar = decimalNum.substr(i, 1)
        // console.log('decChar', decChar)
        if (decChar !== '0') {
          chineseStr += cnNums[parseInt(decChar)] + cnDecUnits[i]
        }
        if (decChar === '0' && parseInt(integerNum, 10) > 0) {
          chineseStr += cnNums[parseInt(decChar)] + cnDecUnits[i]
        }
      }
    } else {
      chineseStr += cnInteger
    }
    return chineseStr
  }
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime (type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass (ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 下载文件
export function downloadFile (url, title) {
  // console.log('url', url, title)
  // const url = window.URL.createObjectURL(new Blob([obj], { type: 'application/vnd.ms-excel' }))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  // const fileName = name + '_' + parseTime(new Date()) + '.' + suffix
  const fileName = title
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  // console.log('下载文件', url, link, fileName)
  document.body.removeChild(link)
}
export function getTimeDiff (dateBegin, dateEnd) {
  // console.log('dateBegin', dateBegin)
  var timeFn = ''
  if (dateEnd === null || dateEnd === undefined) {
    timeFn = ''
  } else {
    var dateDiff = dateEnd - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    // var leave4=leave3%(60*1000)   //计算分钟数后剩余的毫秒数
    // var minseconds=Math.round(leave4/1000)
    if (dayDiff !== 0) {
      timeFn += dayDiff + '天 '
    }
    if (hours !== 0) {
      timeFn += hours + '小时'
    }
    if (minutes !== 0) {
      timeFn += minutes + '分'
    }
    if (seconds !== 0) {
      timeFn += seconds + '秒'
    }
    if (dayDiff === 0 && hours === 0 && minutes === 0 && seconds === 0) {
      timeFn = '<1秒'
    }
  }
  return timeFn
}

export function updateVal (vm) {
  vm.$forceUpdate()
}
// 计算两个日期的天数差
export function dateDiff (firstDate, secondDate) {
  let first = new Date(firstDate)
  let second = new Date(secondDate)
  var result
  if (first.getTime() < second.getTime()) {
    var diff = Math.abs(first.getTime() - second.getTime())
    result = parseInt(diff / (1000 * 60 * 60 * 24))
    console.log('result', result)
  } else {
    result = 0
    console.log('过期')
  }

  return result
}

// 将日期转换为yyyy-mm-dd的格式
export function formatDate (date) {
  /* eslint-disable */
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  return [year, month, day].join('-')
}



// WEBPACK FOOTER //
// ./src/utils/index.js